import { z } from 'zod'

const ScheduleSchema = z.object({
  id: z.number(),
  workOrderId: z.number(),
  lotNo: z.string().nullable(),
  productionType: z.string(),
  machine: z.string(),
  startDate: z.string(),
  qty: z.number(),
})

export const Wo1010GetResultSchema = z.object({
  number: z.string(),
  date: z.coerce.date(),
  deliveryDate: z.coerce.date(),
  productionDate: z.coerce.date(),
  partyId: z.number().nullable(),
  customerItemCode: z.string().nullable(),
  itemId: z.number(),
  refNo: z.string().nullish(),
  refDate: z.string().nullish(),
  remark: z.string().nullish(),
  status: z.number(),
  qty: z.number(),
  isTestProduction: z.boolean(),
  schedules: z.array(ScheduleSchema),
})

export type Wo1010GetResultModel = z.input<typeof Wo1010GetResultSchema>

export type ScheduleModel = z.input<typeof ScheduleSchema>
